// Spark / hero-слайдер главной (порт initSlider из main.js ecomzy-mall).
// Fade-переключение absolute-слайдов + glow-подсветки цветами слайда
// + дот-навигация + стрелки + свайп + автоплей 5с (пауза на hover).
// Разметка: volt/includes/hero-slider И stories-hero (те же классы/ids).
//
// Мультиинстанс: на странице может жить НЕСКОЛЬКО слайдеров
// (hero_slider + stories_hero конструктора) - каждый корень
// .slider-section инитится изолированно, все селекторы (включая
// дублирующиеся между секциями ids макета) ищутся ОТ КОРНЯ секции,
// а не по документу.

export function initHeroSlider() {

    document.querySelectorAll('.slider-section').forEach( root => initOne( root ) );
}

function initOne( root ) {

    const slides = root.querySelectorAll('.slide');
    const dots   = root.querySelectorAll('.slider-dot');
    const prev   = root.querySelector('#sliderPrev');
    const next   = root.querySelector('#sliderNext');
    const glowL  = root.querySelector('#glowLeft');
    const glowR  = root.querySelector('#glowRight');
    const glowT  = root.querySelector('#glowTop');

    if( ! slides.length )
        return;

    let current = 0;
    let autoplay;

    const total = slides.length;

    function goTo( n ) {
        current = n;
        slides.forEach( ( s, i ) => {
            s.style.opacity       = i === n ? '1' : '0';
            s.style.zIndex        = i === n ? '2' : '1';
            s.style.pointerEvents = i === n ? 'auto' : 'none';
        } );
        dots.forEach( ( d, i ) => d.classList.toggle( 'active', i === n ) );

        // Glow-подсветки цветами активного слайда
        const s = slides[ n ];
        if( glowL ) glowL.style.background = s.dataset.glowL || 'transparent';
        if( glowR ) glowR.style.background = s.dataset.glowR || 'transparent';
        if( glowT ) glowT.style.background = s.dataset.glowT || 'transparent';
    }

    function nextSlide() {
        goTo( ( current + 1 ) % total );
    }

    function prevSlide() {
        goTo( ( current - 1 + total ) % total );
    }

    function resetAuto() {
        clearInterval( autoplay );
        autoplay = setInterval( nextSlide, 5000 );
    }

    if( prev )
        prev.addEventListener( 'click', () => {
            prevSlide();
            resetAuto();
        } );

    if( next )
        next.addEventListener( 'click', () => {
            nextSlide();
            resetAuto();
        } );

    dots.forEach( d => d.addEventListener( 'click', () => {
        goTo( + d.dataset.slide );
        resetAuto();
    } ) );

    // Свайп на тач-устройствах
    let touchX = 0;
    const vp = root.querySelector('.slider-viewport');

    if( vp ) {
        vp.addEventListener( 'touchstart', e => {
            touchX = e.touches[0].clientX;
        }, { passive: true } );

        vp.addEventListener( 'touchend', e => {
            const diff = touchX - e.changedTouches[0].clientX;
            if( Math.abs( diff ) > 50 ) {
                diff > 0 ? nextSlide() : prevSlide();
                resetAuto();
            }
        } );
    }

    // Пауза автоплея на hover
    const wrap = root.querySelector('.slider-wrap');
    if( wrap ) {
        wrap.addEventListener( 'mouseenter', () => clearInterval( autoplay ) );
        wrap.addEventListener( 'mouseleave', () => resetAuto() );
    }

    goTo( 0 );
    resetAuto();
}